import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { SignatureElectronic } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';
import { Injectable } from '@angular/core';
import { StatusEnum } from '@app/forms/subscription/definition/interface/enum';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead, option?) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const isCristalisOrganization = option?.isCristalisOrganization || false;
    const formConfig: FormConfig<SignatureElectronic> = {
      conditionGeneralUtilisationAccepte: [
        parameters?.conditionGeneralUtilisationAccepte || false,
        isCristalisOrganization
          ? Validators.nullValidator
          : Validators.requiredTrue,
      ],
      termesDuContratAccepte: [
        parameters?.termesDuContratAccepte || false,
        isCristalisOrganization
          ? Validators.nullValidator
          : Validators.requiredTrue,
      ],
      variationDeValeurAChargeAccepte: [
        parameters?.variationDeValeurAChargeAccepte || false,
        isCristalisOrganization
          ? Validators.nullValidator
          : Validators.requiredTrue,
      ],
      exactitudeDesInformationsAccepte: [
        parameters?.exactitudeDesInformationsAccepte || false,
        isCristalisOrganization
          ? Validators.nullValidator
          : Validators.requiredTrue,
      ],
      politiqueDeProtectionDesDonneesAccepte: [
        parameters?.politiqueDeProtectionDesDonneesAccepte || false,
        isCristalisOrganization
          ? Validators.nullValidator
          : Validators.requiredTrue,
      ],
    };

    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return { ...this.form.value };
  }
}
